import { Component, AfterViewInit, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { captchaValidator, captchaValidatorPl, numbDots } from '../services/validators'
import {Location} from '@angular/common';
import * as moment from 'moment';


import {PlateregionService} from "../nz-search/plateregion.service";
import {PlatetscService} from "../nz-search/platetsc.service";

import * as $ from 'jquery';


import { from } from 'rxjs';
import { Subject } from 'rxjs';
import { compileComponentFromMetadata } from '@angular/compiler';

@Component({
  selector: 'app-nz-search',
  templateUrl: './nz-search.component.html',
  styleUrls: ['./nz-search.component.css'],
  providers:[PlateregionService, PlatetscService],
  encapsulation: ViewEncapsulation.None,
})
export class NzSearchComponent implements OnDestroy,OnInit {

  @ViewChild('selectRegion') public selectRegion: ElementRef;
  @ViewChild('selectTSC') public selectTSC: ElementRef;
  @ViewChild('btnTsc') public btnTsc: ElementRef;
  @ViewChild('btnComb') public btnComb: ElementRef;
 
  deptsc = '';
  depreg = '';
  dnzTscSelect:any ='';
  dnzCombinationSelect:any ='';
  numberPlate = '';
  test:any = '';
  bla:any= '';

  dataTSC:any = [];
  dropDownDataRegion:any = [];
  dropDownDataTSC:any = [];

  dtOptions: DataTables.Settings = {};
  dtOptionsPlates: DataTables.Settings = {};

  dtTrigger: Subject<NzSearchComponent> = new Subject();
  dtTriggerPlate: Subject<NzSearchComponent> = new Subject();

  addData: FormGroup;
  addDataComb: FormGroup;

  time:any;
  timePl:any;

  formErrors = {
    "depreg": "",
    "deptsc": "",
    "number": "",
    "depregcomb": "",
  };

  validationMessages = {
    "depreg": {
        "required": "Обов'якове поле.",
        "captchaValidator": "Підтвердіть Recaptcha додатково.",
    },
    "depregcomb": {
      "required": "Обов'якове поле.",
  },
    "deptsc": {
        "required": "Обов'якове поле.",
        "captchaValidator": "Підтвердіть Recaptcha додатково.",
 
    },
    "number": {
      "required": "Обов'якове поле.",
      "pattern": "Має бути цілі цифри.              ",
      "maxlength": "Максимум 4 цифри.              ",
      "minlength": "Мінімум 4 цифри.  ",
      "captchaValidatorPl": "Підтвердіть Recaptcha додатково.",
  }
  };

  constructor(private regserv: PlateregionService, private router: Router, private http: HttpClient, private fb: FormBuilder) { }

  ngOnInit() {

    this.buildForm();
    this.buildFormComb();

    this.dropDownDataRegion = this.regserv.getDataRegion();
    // this.dataTSC = this.tsccode.getTSCcode();
    localStorage.removeItem("verified");
    localStorage.removeItem("verifiedPl");
 
  }
  
  // onOptionsSelectedRegion(value:string){

  //   this.http.get('https://10.123.171.4/dictions-service/curdepts/regid?regid=' + value )
  //   .subscribe (
  //     data => {
  //       this.test = data;
  //       this.dropDownDataTSC = this.test.filter((tscObject:any) => tscObject.regId === +value);
  //       // this.selectTSC.nativeElement.disabled = !value;
  //     }
  //   )

  // }

  onOptionsSelectedTSC(value:string) {
    this.selectTSC.nativeElement.disabled = !value;
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    this.dtTriggerPlate.unsubscribe();
  }

  onOptionsFindTSC() {
    document.getElementById('linkTSC').style.display = "block";
    document.getElementById('color-obl').style.color = "#00bc6f";
    document.getElementById('color-numb').style.color = "#4e0202";
    document.getElementById('linkNumberComb').style.display = "none";
    document.getElementById('linkTSC').classList.add('animate__animated', 'animate__zoomIn');
  }

  onOptionsFindCombNumb() {
    document.getElementById('linkNumberComb').classList.add('animate__animated', 'animate__zoomIn');
    document.getElementById('color-obl').style.color = "#4e0202";
    document.getElementById('color-numb').style.color = "#00bc6f";
    document.getElementById('linkNumberComb').style.display = "block";
    document.getElementById('linkTSC').style.display = "none";
  }

  buildForm() {
    this.addData = this.fb.group({
        "depreg": ['', [
            Validators.required, 
            captchaValidator,          
        ]]
    });

    this.addData.valueChanges
        .subscribe(data => this.onValueChange(data));

    this.onValueChange();
  }

  buildFormComb() {
    this.addDataComb = this.fb.group({
      "depregcomb": ['', [
        Validators.required,           
    ]],
        "number": ['', [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(4),
            Validators.pattern("\\d+"),
            captchaValidatorPl,
        ]],
    });

    this.addDataComb.valueChanges
        .subscribe(data => this.onValueChangeComb(data));

    this.onValueChangeComb();
    
    if (this.addDataComb.valid) {
      this.btnComb.nativeElement.className = "button_success";
    }

  }

  onValueChange(data?: any) {

    if (!this.addData) return;
    let form = this.addData;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  }

  onValueChangeComb(data?: any) {

    if (!this.addDataComb) return;
    let form = this.addDataComb;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  } 


  resolved(captchaResponse: string) {

    if (captchaResponse != '') {

      localStorage.setItem("verified", "true");
      this.addData.controls['depreg'].updateValueAndValidity();
      this.btnTsc.nativeElement.className = "button_success";

    } else { alert('Ooops! Something go wrong!')}
  }

  resolved_two(captchaResp: string) {

    if (captchaResp != '') {

    localStorage.setItem("verifiedPl", "true");
    this.addDataComb.controls['number'].updateValueAndValidity();
    this.btnComb.nativeElement.className = "button_success";

  } else { alert('Ooops! Something go wrong!')}
  }


  backClicked() {
    /*  this._location.back(); */
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['nz-search']);
  });
  }
  backToMain() {
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['/']);
    // document.getElementById('check-lang').style.display = "flex";
    });
    localStorage.removeItem("verified");
  }

  

  fetchDnzDep(region:any) {
            this.http.get('https://mainapi/licenseplate-service/whs/plates/regionid/' + region)
            .subscribe (
              data => {
                // console.log(data);
                this.dnzTscSelect = data;
                 if (data != null) {
                //  console.log('Its pv');
              //    this.dnzParameters.forEach( (item:any) => {
              //    this.dnzParameters = item.categories;
              //   //  console.log(this.pvCategories);


              this.dtTrigger.next();

              let currentDate = moment().locale('uk');
              this.time = currentDate.format('DD.MM.YYYY HH:mm:ss');

              const enterParam: HTMLElement = document.getElementById('first');
              const outData: HTMLElement = document.getElementById('second');

              enterParam.classList.add('animate__animated', 'animate__zoomOutDown');
              setTimeout(() => enterParam.hidden = true, 900);

              outData.classList.add('animate__animated', 'animate__zoomInDown');
              setTimeout(() => document.getElementById("second").style.display = "block", 900);

              } else {
                console.log('Not found '); 
                this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                  this.router.navigate(['message']);
                  }); 
              }
            },
                 err => console.log(err)
            )

            this.dtOptions = {
              pagingType: 'full_numbers',
              pageLength: 10,
              language: {
                 processing: "Зачекайте...",
                 lengthMenu:   "Показати _MENU_ записів",
                 zeroRecords:  "Записи відсутні.",
                 info: "Записи з _START_ по _END_ із _TOTAL_ записів",
                 infoEmpty:    "Записи з 0 по 0 із 0 записів",
                 infoFiltered: "(відфільтровано з _MAX_ записів)",
                 infoPostFix:  "",
                 search:       "Пошук:",
                 url:          "",
              paginate: {
                first: "Перша",
                previous: "Попередня",
                next: "Наступна",
                last: "Остання"
              },
              aria: {
            sortAscending:  ": активувати для сортування стовпців за зростанням",
            sortDescending: ": активувати для сортування стовпців за спаданням"
        }
          
          }
        };

      }

      fetchDnzNumb(regionPl:any, plate:any) {
        this.http.get('https://10.123.171.4/licenseplate-service/whs/plates/regnum?regionid=' + regionPl + '&number=' + plate)
        .subscribe (
          data => {
            // console.log(data);
             this.dnzCombinationSelect = data;
             if (data != null) {
            //  console.log('Its pv');
          //    this.dnzParameters.forEach( (item:any) => {
          //    this.dnzParameters = item.categories;
          //   //  console.log(this.pvCategories);
          this.dtTriggerPlate.next();

          let currentDatePl = moment().locale('uk');
          this.timePl = currentDatePl.format('DD.MM.YYYY HH:mm:ss');

          const outData: HTMLElement = document.getElementById('four');
          const enterParam: HTMLElement = document.getElementById('three');

          enterParam.classList.add('animate__animated', 'animate__zoomOutDown');
          setTimeout(() => enterParam.hidden = true, 900);

          outData.classList.add('animate__animated', 'animate__zoomInDown');
          setTimeout(() => document.getElementById("four").style.display = "block", 900);

          //  });
          } else {
            console.log('Not found '); 
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['message']);
              }); 
          }
        },
             err => console.log(err)
        )

        this.dtOptionsPlates = {
          pagingType: 'full_numbers',
          pageLength: 10,
          language: {
             processing: "Зачекайте...",
             lengthMenu:   "Показати _MENU_ записів",
             zeroRecords:  "Записи відсутні.",
             info: "Записи з _START_ по _END_ із _TOTAL_ записів",
             infoEmpty:    "Записи з 0 по 0 із 0 записів",
             infoFiltered: "(відфільтровано з _MAX_ записів)",
             infoPostFix:  "",
             search:       "Пошук:",
             url:          "",
          paginate: {
            first: "Перша",
            previous: "Попередня",
            next: "Наступна",
            last: "Остання"
          },
          aria: {
        sortAscending:  ": активувати для сортування стовпців за зростанням",
        sortDescending: ": активувати для сортування стовпців за спаданням"
    }
      
      }
    };

  }

}
